// Module
var code = "<template> <require from=\"app/core/components/documents/documents-grid\"></require> <documents-grid target-id.bind=\"caseId\" documents-config.bind=\"documentsConfig\" readonly.bind=\"readonly\"></documents-grid> </template> ";
// Exports
module.exports = code;